<template>
  <div class="chart-placeholder">{{ message }}</div>
</template>

<script>
export default {
  name: 'ChartPlaceholder',
  props: {
    message: String,
  },
}
</script>

<style lang="postcss" scoped>
.chart-placeholder {
  @apply text-gray-500;
  @apply pl-4;
}
</style>
